export default __webpack_public_path__ + "media/images/loader/loader-black-hole.jpg";